import React, { useState, useContext, useEffect } from "react";
import Head from "../Head/Head";
import Squares from "../Squares/Squares";
import Text from "../Text/Text";
import Elements from "../Elements/Elements";
import cx from "classnames";
import "./StepSix.scss";
import plusshape from "../../assets/plusshape.svg";
import high from "../../assets/high.svg";
import medium from "../../assets/medium.svg";
import low from "../../assets/low.svg";
import { SquareContext } from "../../SquareContext";

function StepSix(props) {
  const {
    state,
    setState,
    listEdge,
    edge,
    initialColor,
    activeColor,
    edgeid,
    edgesx,
    stepDesc,
    cart,
    unity2,
    unity3,
  } = useContext(SquareContext);
  const [btnColor6, setBtnColor6] = useState(initialColor);
  const [activeIndex, setActiveIndex] = useState();

  useEffect(() => {
    if (edge.length !== 0) {
      setBtnColor6(activeColor);
    } else {
      setBtnColor6(initialColor);
    }
  }, [edge]);

  useEffect(() => {
    if (cart.length === 0) {
      props.jump(1);
    }
  }, [cart]);

  useEffect(() => {
    if (unity2 === 0 && cart[1] !== undefined) {
      props.jump(3);
    }
  }, [cart, unity2]);

  useEffect(() => {
    if (unity3 === 0 && cart[2] !== undefined) {
      props.jump(3);
    }
  }, [cart, unity3]);

  const handleNext = () => {
    if (btnColor6 === activeColor) {
      props.next();
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div className="stepFiver">
     

        {stepDesc[5] && (
        <div>
          <div className="head">
            <p className="head-red">STEP 6</p>
            <p className="head-line">I</p>
            <p  dangerouslySetInnerHTML={{ __html: stepDesc[5].title }}></p>
          </div>
        </div>
      )}

        <div className="stone">
          <Squares
            first={() => {
              if (props.order === 6) {
                props.jump(1);
              } else {
                props.jump(6);
              }
            }}
            second={() => {
              if (props.order === 6) {
                props.jump(1);
              } else {
                props.jump(6);
              }
            }}
            third={() => {
              if (props.order === 6) {
                props.jump(1);
              } else {
                props.jump(6);
              }
            }}
          />
          {stepDesc[5] !== undefined && (
            <div className="text-middle"
            dangerouslySetInnerHTML={{ __html: stepDesc[5].description }}
            >
              {/* <Text
                desc={stepDesc[5] !== undefined && stepDesc[5].description}
              /> */}
            </div>
          )}
            <div className="buttons">
              <button
                className="btn-prev"
                onClick={props.prev}
                style={{ background: "#ff262d" }}
              >
                BACK STEP
              </button>
              <button
                className="btn-next"
                onClick={handleNext}
                style={{ background: btnColor6 }}
              >
                NEXT STEP
              </button>
            </div>
        </div>
        <div className="shapes-step6">
          <Elements eleclass="elements" />

          <div className="shapes-form-container-step6">
            <div className="expense">
              <p>Level of Expense:</p>
              <img src={high} alt="high" />
              <span>HIGH</span>
              <img src={medium} alt="medium" />
              <span>MEDIUM</span>
              <img src={low} alt="low" />
              <span>LOW</span>
            </div>
            <div className="shapes-form-step6">
              <div
                className={cx(
                  "mrg-cont6 six1",
                  edge.find((obj) => obj.id === 1) ? "active" : ""
                )}
              >
                <div className=" mrg3  sv">{listEdge[0]}</div>
              </div>
              <div
                className={cx(
                  "mrg-cont6 six2",
                  edge.find((obj) => obj.id === 2) ? "active" : ""
                )}
              >
                <div className=" mrg3 sv">{listEdge[1]}</div>
              </div>
              <div
                className={cx(
                  "mrg-cont6 six3",
                  edge.find((obj) => obj.id === 3) ? "active" : ""
                )}
              >
                <div className=" mrg3  sv">{listEdge[2]}</div>
              </div>
              <div
                className={cx(
                  "mrg-cont6",
                  edge.find((obj) => obj.id === 4) ? "active" : ""
                )}
              >
                <div className=" mrg3 sv">{listEdge[3]}</div>
              </div>
              <div
                className={cx(
                  "mrg-cont6 ostatni",
                  edge.find((obj) => obj.id === 5) ? "active" : ""
                )}
              >
                <div className=" mrg3 sv">{listEdge[4]}</div>
              </div>
              <div
                className={cx(
                  "mrg-cont6 ostatni",
                  edge.find((obj) => obj.id === 6) ? "active" : ""
                )}
              >
                <div className=" mrg3 sv">{listEdge[5]}</div>
              </div>
              <div
                className={cx(
                  "mrg-cont6 ostatni",
                  edge.find((obj) => obj.id === 7) ? "active" : ""
                )}
              >
                <div className=" mrg3 sv">{listEdge[6]}</div>
              </div>
              <div
                className={cx(
                  "mrg-cont6 ostatni",
                  edge.find((obj) => obj.id === 8) ? "active" : ""
                )}
              >
                <div className=" mrg3 sv">{listEdge[7]}</div>
              </div>
              <div
                className={cx(
                  "mrg-cont6 ostatni",
                  edge.find((obj) => obj.id === 9) ? "active" : ""
                )}
              >
                <div className=" mrg3 sv">{listEdge[8]}</div>
              </div>
              <div
                className={cx(
                  "mrg-cont6 ostatni",
                  edge.find((obj) => obj.id === 10) ? "active" : ""
                )}
              >
                <div className=" mrg3 sv">{listEdge[9]}</div>
              </div>
              <div
                className={cx(
                  "mrg-cont6 ostatni",
                  edge.find((obj) => obj.id === 11) ? "active" : ""
                )}
              >
                <div className=" mrg3 sv">{listEdge[10]}</div>
              </div>
              <div
                className={cx(
                  "mrg-cont6 ostatni",
                  edge.find((obj) => obj.id === 12) ? "active" : ""
                )}
              >
                <div className=" mrg3 sv">{listEdge[11]}</div>
              </div>
              <div
                className={cx(
                  "mrg-cont6 ostatni",
                  edge.find((obj) => obj.id === 13) ? "active" : ""
                )}
              >
                <div className=" mrg3 sv">{listEdge[12]}</div>
              </div>
              <div
                className={cx(
                  "mrg-cont6 ostatni",
                  edge.find((obj) => obj.id === 14) ? "active" : ""
                )}
              >
                <div className=" mrg3 sv">{listEdge[13]}</div>
              </div>
              <div
                className={cx(
                  "mrg-cont6 ostatni",
                  edge.find((obj) => obj.id === 15) ? "active" : ""
                )}
              >
                <div className=" mrg3 sv">{listEdge[14]}</div>
              </div>
              <div
                className={cx(
                  "mrg-cont6 ostatni",
                  edge.find((obj) => obj.id === 16) ? "active" : ""
                )}
              >
                <div className=" mrg3 sv">{listEdge[15]}</div>
              </div>
            </div>

            {/* <div className="shapes-form-step6">
              {listEdge.map((el) => (
                <div
                  key={el.key}
                  className={cx(
                    "mrg-cont6",
                    edge.find((obj) => obj.id === el.key) ? "active" : ""
                  )}
                >
                  <div key={el.key} className=" mrg3 sv">
                    {el}
                  </div>
                </div>
              ))}
            </div> */}
            <div className="buttons btn-dwn6">
              <button
                className="btn-prev"
                onClick={props.prev}
                style={{ background: "#ff262d" }}
              >
                BACK STEP
              </button>
              <button
                className="btn-next"
                onClick={handleNext}
                style={{ background: btnColor6 }}
              >
                NEXT STEP
              </button>
            </div>
          </div>
        </div>
        <div>
         
        </div>
      </div>
    </>
  );
}

export default StepSix;
